import { SideBarElementsType } from "@/common/types";
import {
  AccountIcon,
  BuildingsIcon,
  DashboardIcon,
  DocumentsIcon,
  NotificationIcon,
  PriceIcon,
  QuotesIcon,
  ServicesIcon,
} from "../icon";

const airx: SideBarElementsType[] = [
  {
    icon: <DashboardIcon />,
    label: "Dashboard",
    to: "/",
  },
  {
    icon: <NotificationIcon />,
    label: "Notifications feed",
    to: "/notification",
  },
  {
    icon: <QuotesIcon />,
    label: "Quotes",
    to: "/quotes",
  },
  {
    icon: <AccountIcon />,
    label: "Accounts",
    to: "/accounts",
  },
  {
    icon: <DocumentsIcon />,
    label: "Documents",
    to: "/documents",
  },
  {
    icon: <BuildingsIcon />,
    label: "Buildings list",
    to: "/buildings-list",
  },
  {
    icon: <PriceIcon />,
    label: "Price list",
    to: "/price-list",
  },
  {
    icon: <ServicesIcon />,
    label: "Services",
    to: "/services",
  },
];
const vendor: SideBarElementsType[] = [
  {
    icon: <DashboardIcon />,
    label: "Dashboard",
    to: "/me",
  },
  {
    icon: <NotificationIcon />,
    label: "Notifications feed",
    to: "/notification",
  },
  {
    icon: <QuotesIcon />,
    label: "Quotes",
    to: "/vendor/quotes/me",
  },
  {
    icon: <AccountIcon />,
    label: "My company",
    to: "/company/me",
  },
  {
    icon: <DocumentsIcon />,
    label: "Documents",
    to: "/documents/me",
  },
  {
    icon: <BuildingsIcon />,
    label: "Buildings list",
    to: "/buildings/me",
  },
  {
    icon: <PriceIcon />,
    label: "Price list",
    to: "/price-list/me",
  },
  {
    icon: <ServicesIcon />,
    label: "Services",
    to: "/services/vendor/me",
  },
];
const customer: SideBarElementsType[] = [
  {
    icon: <DashboardIcon />,
    label: "Dashboard",
    to: "/me",
  },
  {
    icon: <NotificationIcon />,
    label: "Notifications feed",
    to: "/notification",
  },
  {
    icon: <QuotesIcon />,
    label: "Quotes",
    to: "customer/quotes/me",
  },
  {
    icon: <AccountIcon />,
    label: "My company",
    to: "company/me",
  },
  {
    icon: <DocumentsIcon />,
    label: "Documents",
    to: "/documents/me",
  },
  {
    icon: <ServicesIcon />,
    label: "Services",
    to: "/services/customer/me",
  },
];
type SideBarType = {
  airx: SideBarElementsType[];
  vendor: SideBarElementsType[];
  customer: SideBarElementsType[];
};
export const sideBarElements: SideBarType = { airx, customer, vendor };
